import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var CustomizeFilter = function CustomizeFilter(props) {
  var optionKey = props.optionKey,
      value = props.value,
      onChange = props.onChange,
      render = props.render;
  return _jsxs("div", {
    className: "igloo-form-filter-drop-down-container-content-group",
    children: [render(value, onChange), _jsx(_Divider, {
      style: {
        margin: '16px 0px'
      }
    })]
  }, optionKey);
};

export default CustomizeFilter;